import { onIdleCallback } from './idleCallback';

class ModuleLoader {
	constructor(data = {}, el = document.body) {
		this.data = data;
		this.el = el;
		this.modules = [];
	}

	load() {
		const data = this.data; // eslint-disable-line prefer-destructuring
		// Query all the matching elements, but not when it already has the attribute `data-module-loaded`
		// TODO: Define a condition to check which modules are already loaded instead of looking for the general `data-module-loaded` attribute
		const els = Array.from(
			this.el.querySelectorAll('[data-module]:not([data-module-loaded])')
		);

		els.forEach((el, index) => {
			const { module, modulePriority } = el.dataset;
			const moduleStrings = module.split(' ');

			moduleStrings.forEach((moduleString) => {
				const Module = data[moduleString];

				if (Module) {
					const module = new Module(el);

					this.modules.push(module);

					if (modulePriority && modulePriority === 'instant') {
						module.render(index);
					} else {
						onIdleCallback(() => {
							module.render(index);
						});
					}

					el.dataset.moduleLoaded = true;
				} else {
					console.warn(`Module with name ${module} not found`);
				}
			});
		});

		// Set return value to this ModuleLoader instance for convenience:
		return this;
	}
}

export default ModuleLoader;
